import { useState } from 'react';

type PlayerAvatarProps = {
  imageUrl?: string;
  alt?: string;
  className?: string;
};

/** A grey figure for players the feed has no photo for, or whose photo fails to load. */
const Silhouette = () => (
  <svg
    viewBox="0 0 64 64"
    aria-hidden="true"
    className="h-full w-full"
    data-cy="player-avatar-placeholder"
  >
    <rect width="64" height="64" fill="#e4e7ea" />
    <circle cx="32" cy="24" r="12" fill="#a7adb3" />
    <path d="M10 64c2-14 11-21 22-21s20 7 22 21z" fill="#a7adb3" />
  </svg>
);

/**
 * Round headshot with a fallback. The API hands out an image URL for every
 * player, but some of them are dead links, so a broken load has to fall back
 * as well as a missing URL.
 */
export const PlayerAvatar = ({
  imageUrl,
  alt = '',
  className = ''
}: PlayerAvatarProps) => {
  const [hasError, setHasError] = useState(false);
  const showImage = Boolean(imageUrl) && !hasError;

  return (
    <span
      className={`flex items-center justify-center overflow-hidden rounded-full bg-[#e4e7ea] ${className}`}
    >
      {showImage ? (
        <img
          src={imageUrl}
          alt={alt}
          className="!mb-0 h-full w-full origin-bottom scale-110 object-cover"
          onError={() => setHasError(true)}
        />
      ) : (
        <Silhouette />
      )}
    </span>
  );
};
